"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalize = capitalize;
/**
 * zamienia pierwszą literę każdego wyrazu na wielką, pozostałe na małe
 *
 * @param value wartośc do zmiany
 */
function capitalize(value) {
    //return value.toLocaleLowerCase().replace(/\w[^\s-]*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())));
    const tt = value.toLocaleLowerCase();
    // let tt = value;
    let result = '';
    let isFirstLetter = true;
    for (let i = 0; i < tt.length; i++) {
        const c = tt[i];
        if (c == ' ' || c == '\t' || c == "\r" || c == "\n" || c == "-" || c == "," || c == "." || c == "_") {
            result += c;
            isFirstLetter = true;
        }
        else {
            if (isFirstLetter) {
                result += c.toLocaleUpperCase();
                isFirstLetter = false;
            }
            else {
                result += c;
            }
        }
    }
    return result;
}
exports.default = capitalize;
//# sourceMappingURL=capitalize.js.map